import { AxiosInstance } from 'axios';
import { axiosProxy } from '@/plugins/axios';

export class CountryRepository {
  private api: AxiosInstance = axiosProxy;
  private countries: any[] = [];

  async getCountries() {
    if (this.countries.length) return this.countries;
    try {
      const res = await this.api.get('countries');
      if (res.data['data'] instanceof Array) {
        this.countries = res.data['data'];
        return this.countries;
      }
      throw Error("Data is not array");
    } catch (error) {
      throw error;
    }
  }

}